import React from 'react';
import parse from 'html-react-parser';

export default function ChecklistItemTitle({title}) {
  return title && (<div className="app-checklist-item-title">{parse(title)}</div>);
}
